<section class="flex flex-col w-full page-wrapper">
  <div class="w-full py-4 block sm:hidden">
    <go-back></go-back>
  </div>
  <div class="text-center pb-10 sm:pb-12">
    <h2 class="heading-medium extra-bold">{{ 'okeeyCash.myOkeeyCash' | translate }}</h2>
  </div>
  <div class="flex w-full px-4 pt-6 pb-8 sm:px-10 sm:pt-8 sm:pb-10 header-card-container">
    @for (item of headerCard; track item; let i = $index) {
      <div class="flex flex-col justify-center items-center gap-6 w-full">
        <div class="w-12 h-auto sm:w-16">
          <img [src]="item.imgSrc" [alt]="item.imgAlt" />
        </div>
        <h2 class="heading-small outfit">
          {{
            i === 0
              ? '$' + (depositValue | thousandsSeparator: true) + ' / $750'
              : referralValue > 5
                ? referralValue
                : referralValue + ' / 5'
          }}
        </h2>
        <div
          class="paragraph-medium outfit"
          [ngClass]="{
            eligible: (i === 0 && hasDepositedEnough) || (i === 1 && hasReferredCustomer),
            'not-eligible': (i === 0 && !hasDepositedEnough) || (i === 1 && !hasReferredCustomer)
          }"
        >
          {{ item.textKey | translate }}
        </div>
      </div>
      @if (i < headerCard.length - 1) {
        <div class="vertical-stroke">
          <svg xmlns="http://www.w3.org/2000/svg" width="2" height="167" viewBox="0 0 2 167" fill="none">
            <path d="M1 0V167" stroke="#EEEEEF" />
          </svg>
        </div>
      }
    }
  </div>
  <div class="py-4 mt-4 mb-6 sm:mt-6 flex items-center justify-center header-card-container">
    <p
      class="paragraph-medium m-0 flex justify-center items-center outfit gap-1"
      [ngClass]="{ eligible: isEligible, 'not-eligible': !isEligible }"
    >
      {{ isEligible ? ('okeeyCash.eligible' | translate) : ('okeeyCash.notEligible' | translate) }}
      @if (isEligible) {
        <i nz-icon>
          <span
            class=""
            nzTooltipPlacement="bottomRight"
            nz-tooltip
            appHideTooltipOnScroll
            nzTooltipTitle="{{ 'okeeyCash.USEligibility' | translate }}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <path
                d="M8.4974 14.666C4.8154 14.666 1.83073 11.6807 1.83073 7.99935C1.83073 4.31801 4.8154 1.33268 8.4974 1.33268C12.1794 1.33268 15.1641 4.31802 15.1641 7.99935C15.1641 11.6807 12.1794 14.666 8.4974 14.666ZM8.4974 13.5547C11.5607 13.5547 14.0527 11.0627 14.0527 7.99935C14.0527 4.93602 11.5607 2.44402 8.4974 2.44401C5.43406 2.44401 2.94206 4.93601 2.94206 7.99935C2.94206 11.0627 5.43406 13.5547 8.4974 13.5547ZM8.49826 6.33121C8.1306 6.33121 7.83253 6.03308 7.83253 5.66541C7.83253 5.29775 8.1306 4.99962 8.49826 4.99962C8.866 4.99962 9.16406 5.29775 9.16406 5.66541C9.16406 6.03308 8.866 6.33121 8.49826 6.33121ZM8.50106 11.3327C8.24793 11.3329 8.0386 11.1449 8.00533 10.9009L8.00066 10.8331L7.99826 7.83201C7.99806 7.55588 8.22173 7.33181 8.49786 7.33161C8.751 7.33141 8.9604 7.51935 8.99366 7.76335L8.99826 7.83121L9.00066 10.8323C9.00093 11.1084 8.77726 11.3325 8.50106 11.3327Z"
                fill="#393E44"
              />
            </svg>
          </span>
        </i>
      }
      @if (!isEligible) {
        <i nz-icon>
          <span
            class=""
            nzTooltipPlacement="bottomRight"
            nz-tooltip
            appHideTooltipOnScroll
            nzTooltipTitle="{{ 'okeeyCash.USEligibility' | translate }}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <path
                d="M8.4974 14.666C4.8154 14.666 1.83073 11.6807 1.83073 7.99935C1.83073 4.31801 4.8154 1.33268 8.4974 1.33268C12.1794 1.33268 15.1641 4.31802 15.1641 7.99935C15.1641 11.6807 12.1794 14.666 8.4974 14.666ZM8.4974 13.5547C11.5607 13.5547 14.0527 11.0627 14.0527 7.99935C14.0527 4.93602 11.5607 2.44402 8.4974 2.44401C5.43406 2.44401 2.94206 4.93601 2.94206 7.99935C2.94206 11.0627 5.43406 13.5547 8.4974 13.5547ZM8.49826 6.33121C8.1306 6.33121 7.83253 6.03308 7.83253 5.66541C7.83253 5.29775 8.1306 4.99962 8.49826 4.99962C8.866 4.99962 9.16406 5.29775 9.16406 5.66541C9.16406 6.03308 8.866 6.33121 8.49826 6.33121ZM8.50106 11.3327C8.24793 11.3329 8.0386 11.1449 8.00533 10.9009L8.00066 10.8331L7.99826 7.83201C7.99806 7.55588 8.22173 7.33181 8.49786 7.33161C8.751 7.33141 8.9604 7.51935 8.99366 7.76335L8.99826 7.83121L9.00066 10.8323C9.00093 11.1084 8.77726 11.3325 8.50106 11.3327Z"
                fill="#393E44"
              />
            </svg>
          </span>
        </i>
      }
    </p>
  </div>
  <nz-tag
    [ngClass]="{ 'is-eligible': isEligible, 'to-be-eligible': !isEligible }"
    class="flex justify-start items-center rounded-lg p-4 mb-6"
  >
    <div class="flex items-center gap-2 sm:gap-4">
      <i nz-icon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2C17.523 2 22 6.478 22 12C22 17.522 17.523 22 12 22C6.477 22 2 17.522 2 12C2 6.478 6.477 2 12 2ZM12.0018 15.0037C11.4503 15.0037 11.0031 15.4508 11.0031 16.0024C11.0031 16.5539 11.4503 17.001 12.0018 17.001C12.5533 17.001 13.0005 16.5539 13.0005 16.0024C13.0005 15.4508 12.5533 15.0037 12.0018 15.0037ZM11.9996 7C11.4868 7.00018 11.0643 7.38638 11.0067 7.88374L11 8.00036L11.0018 13.0012L11.0086 13.1179C11.0665 13.6152 11.4893 14.0011 12.0022 14.0009C12.515 14.0007 12.9375 13.6145 12.9951 13.1171L13.0018 13.0005L13 7.99964L12.9932 7.88302C12.9353 7.3857 12.5125 6.99982 11.9996 7Z"
            fill="#222528"
          />
        </svg>
      </i>
      @if (!isEligible) {
        <p class="font-light inline-block">
          <span class="paragraph-small-card outfit">{{ 'okeeyCash.toAccessOkeeyCashAlert' | translate }}</span>
          <a routerLink="tutorial" class="paragraph-small-card outfit underline cursor-pointer">{{
            'okeeyCash.hereAlert' | translate
          }}</a>
          <span class="paragraph-small-card outfit">{{ 'okeeyCash.getStartedAlert' | translate }}</span>
        </p>
      }
      @if (isEligible) {
        <p class="font-light inline-block">
          <span class="paragraph-small-card outfit">{{
            'myGanarbols.yourEligibilityWillBeginAsSoon' | translate
          }}</span>
        </p>
      }
    </div>
  </nz-tag>
  <korviu-button
    type="button"
    color="tertiary"
    [disabled]="!hasokeeyCashInternalUserId"
    (click)="okeeyCashSignIn()"
    class="w-full"
    >{{ 'okeeyCash.signIn' | translate }}</korviu-button
  >
  <div class="flex flex-col w-full mt-8 md:mt-14">
    @for (section of sections; track section; let i = $index) {
      <div class="flex flex-col gap-6 sm:gap-8 pb-8">
        <h4 class="paragraph-medium outfit bold">{{ section.title | translate }}</h4>
        <div class="flex flex-col sm:flex-row gap-4 sm:gap-6 w-full">
          @for (item of section.items; track item) {
            <div
              class="flex items-center gap-4 p-4 w-full cursor-pointer content-card-container"
              [routerLink]="item.link"
            >
              <div class="w-14 h-auto"><img [src]="item.imgSrc" alt="" class="w-full" /></div>
              <div class="flex-grow flex flex-col">
                <h4 class="paragraph-medium outfit">{{ item.title | translate }}</h4>
                <p class="paragraph-medium normal outfit">{{ item.description | translate }}</p>
              </div>
              <div>
                <svg
                  class="self-end"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <path
                    d="M5.64517 13.6875C5.4499 13.4923 5.4499 13.1757 5.64517 12.9804L10.1249 8.50065L5.64517 4.02085C5.4499 3.82558 5.4499 3.50905 5.64517 3.31379C5.84043 3.11852 6.15697 3.11852 6.35223 3.31379L11.1856 8.14712C11.3808 8.34239 11.3808 8.65892 11.1856 8.85419L6.35223 13.6875C6.15697 13.8828 5.84043 13.8828 5.64517 13.6875Z"
                    fill="#505760"
                  />
                </svg>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</section>
